// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Wish_container__Jkm0y {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding: 40px;
  background-color: #f5f5f5;
  overflow-x: hidden;
}
@media (max-width: 768px) {
  .Wish_container__Jkm0y {
    padding: 16px;
  }
}

.Wish_wishContainer__WzQ8Z {
  background: white;
  border-radius: 12px;
  padding: 32px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  min-height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}
@media (max-width: 768px) {
  .Wish_wishContainer__WzQ8Z {
    padding: 20px;
    min-height: calc(100vh - 32px);
  }
}

.Wish_header__DK5q9 {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #eaeaea;
}
.Wish_header__DK5q9 h2 {
  font-size: 1.75rem;
  color: #333;
  margin: 0;
  font-weight: 600;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
.Wish_header__DK5q9 h3 {
  font-size: 1.25rem;
  color: #666;
  margin: 8px 0 0 0;
  font-weight: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.Wish_wishes__P4xlV {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
  overflow-x: hidden;
}

.Wish_wish__XB7An {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  transition: background-color 0.2s ease;
  width: 100%;
  min-width: 0;
}
.Wish_wish__XB7An:hover {
  background: #f0f0f0;
}
.Wish_wish__XB7An .Wish_wishText__J0lRP {
  flex: 1 1;
  min-width: 0;
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
}

.Wish_wishActions__YK1lb {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-shrink: 0;
}
@media (max-width: 768px) {
  .Wish_wishActions__YK1lb {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
  }
}

.Wish_bookingForm__oaV6o {
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;
}
.Wish_bookingForm__oaV6o input {
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 0.875rem;
  min-width: 0;
  width: 100%;
}
.Wish_bookingForm__oaV6o input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}
@media (max-width: 768px) {
  .Wish_bookingForm__oaV6o {
    flex-direction: column;
  }
}

button {
  padding: 8px 16px;
  border-radius: 6px;
  border: none;
  background-color: #007bff;
  color: white;
  cursor: pointer;
  font-size: 0.875rem;
  transition: all 0.2s ease;
  white-space: normal;
  text-align: center;
  min-height: 36px;
}
button:hover:not(:disabled) {
  background-color: #0056b3;
}
button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}
button.Wish_unbookButton__6d3\\+p {
  background-color: #dc3545;
}
button.Wish_unbookButton__6d3\\+p:hover:not(:disabled) {
  background-color: #c82333;
}
button.Wish_searchButton__STmPg {
  background-color: #28a745;
}
button.Wish_searchButton__STmPg:hover:not(:disabled) {
  background-color: #218838;
}
@media (max-width: 768px) {
  button {
    width: 100%;
  }
}

.Wish_bookedStatus__8YM82 {
  font-size: 0.875rem;
  color: #666;
  font-style: italic;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.Wish_loading__D\\+h0A {
  opacity: 0.7;
  pointer-events: none;
}

.Wish_wish__XB7An {
  min-width: 350px;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: min-content;
  align-items: center;
  padding: 16px 16px 32px 16px;
  border-radius: 8px;
  background-color: white;
  box-shadow: 0 4px 6px -1px rgba(255, 255, 255, 0.5), 0px 2px 4px -2px rgba(255, 255, 255, 0.6);
  transition: box-shadow 0.3s ease-in-out;
  text-align: center;
  position: relative;
  max-height: 500px;
}
@media (max-width: 500px) {
  .Wish_wish__XB7An {
    width: 90vw;
  }
}

.Wish_wish__XB7An:hover {
  box-shadow: 0 5px 15px -3px rgba(255, 255, 255, 0.7), 0px 3px 6px -2px rgba(255, 255, 255, 0.8);
}

.Wish_wishes__P4xlV {
  padding-top: 10px;
  overflow: auto;
  width: 100%;
  text-align: left;
}

.Wish_wrapper__7sayo {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
}

.Wish_name__kwRbg {
  position: absolute;
  right: 10px;
  bottom: 4px;
}

.Wish_font__XeY8M {
  font-family: "Times New Roman", sans-serif;
  word-break: break-all;
  cursor: pointer;
  transition: -webkit-text-decoration 0.3s ease;
  transition: text-decoration 0.3s ease;
  transition: text-decoration 0.3s ease, -webkit-text-decoration 0.3s ease;
}

.Wish_font__XeY8M:hover {
  text-decoration: underline;
}

.Wish_row__zPG1s {
  display: flex;
  gap: 6px;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  word-wrap: break-word;
}

.Wish_info__WvpUK {
  display: flex;
}

.Wish_actions__Vy-eo {
  display: flex;
  align-items: center;
  gap: 6px;
}

.Wish_column__vUIF0 {
  padding: 5px;
  border-bottom: 1px solid black;
}

.Wish_popup__R6ZEo {
  background: #282c34;
  display: flex;
  flex-direction: column;
  right: 0;
  margin-left: 8px;
  padding: 20px;
  font-size: 14px;
  border-radius: 8px;
}

.Wish_input__WMDwy {
  cursor: pointer !important;
  border: unset;
  font-size: 16px;
  outline: none;
  padding: 8px;
  border-radius: 10px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(255, 255, 255, 0.3), 0 1px 3px rgba(255, 255, 255, 0.2);
}
.Wish_input__WMDwy:hover {
  box-shadow: 0 10px 15px rgba(255, 255, 255, 0.4), 0 3px 6px rgba(255, 255, 255, 0.3), 0 2px 4px rgba(255, 255, 255, 0.2);
}

.Wish_button__99326 {
  cursor: pointer !important;
  font-size: 16px;
  color: black;
  margin: 10px;
  padding: 8px 16px;
  border-radius: 10px;
  font-family: "RubikMoonrocks", sans-serif;
  background-color: white;
  border: none;
  box-shadow: 0 4px 6px rgba(255, 255, 255, 0.3), 0 1px 3px rgba(255, 255, 255, 0.2);
  transition: transform 0.1s ease, background-color 0.2s ease;
}
.Wish_button__99326:hover {
  box-shadow: 0 10px 15px rgba(255, 255, 255, 0.4), 0 3px 6px rgba(255, 255, 255, 0.3), 0 2px 4px rgba(255, 255, 255, 0.2);
}
.Wish_button__99326:active {
  transform: scale(0.95);
}

.Wish_loading__D\\+h0A {
  filter: blur(1px);
}

.Wish_del__0cyNK {
  text-decoration: line-through;
}

.Wish_toogleHide__AD2lC {
  position: absolute;
  top: 0;
  left: 0;
}

.Wish_christmasContainer__xtg37 {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(to bottom, #1a472a, #2d5a40);
  padding: 20px;
  overflow: hidden;
}

.Wish_lights__3r7UL {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: repeating-linear-gradient(90deg, #ff0000 0px, #ff0000 10px, #00ff00 10px, #00ff00 20px, #0000ff 20px, #0000ff 30px);
  animation: Wish_twinkle__6M5A2 1s infinite;
}

.Wish_wrapper__7sayo {
  position: relative;
  z-index: 1;
}

.Wish_christmasCard__\\+XSod {
  background: rgba(255, 255, 255, 0.9);
  border-radius: 15px;
  padding: 30px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  position: relative;
  margin: 20px auto;
  max-width: 800px;
  border: 2px solid #c41e3a;
}

.Wish_name__kwRbg {
  color: #c41e3a;
  font-size: 1.5em;
  font-weight: bold;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
  margin-bottom: 15px;
  display: block;
}

.Wish_wishTitle__Eo4hS {
  color: #1a472a;
  font-size: 2em;
  margin: 15px 0;
  display: block;
  text-align: center;
}

.Wish_toggleHide__r96OQ {
  background: #c41e3a;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 25px;
  cursor: pointer;
  font-size: 1.1em;
  transition: all 0.3s ease;
  margin: 10px;
}
.Wish_toggleHide__r96OQ:hover {
  background: #8b0000;
  transform: scale(1.05);
}

.Wish_decorations__cxhLH {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: -10px;
  display: flex;
  justify-content: space-around;
  font-size: 24px;
}

.Wish_wishes__P4xlV {
  background: rgba(255, 255, 255, 0.8);
  border-radius: 10px;
  padding: 20px;
  margin: 20px 0;
}

@keyframes Wish_snow__5yp-x {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 0 1536px;
  }
}
@keyframes Wish_twinkle__6M5A2 {
  0% {
    opacity: 0.7;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.7;
  }
}
.Wish_holly__TSmU\\+ {
  position: absolute;
  top: -15px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 30px;
}

@media (max-width: 768px) {
  .Wish_christmasCard__\\+XSod {
    margin: 10px;
    padding: 20px;
  }
  .Wish_name__kwRbg,
  .Wish_wishTitle__Eo4hS {
    font-size: 1.2em;
  }
  .Wish_decorations__cxhLH {
    font-size: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Wish/Wish.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;AACF;AACE;EARF;IASI,aAAA;EAEF;AACF;;AACA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,wCAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,8BAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AAEF;AAAE;EAbF;IAcI,aAAA;IACA,8BAAA;EAGF;AACF;;AAAA;EACE,mBAAA;EACA,oBAAA;EACA,gCAAA;AAGF;AADE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;AAGJ;AAAE;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;AAEJ;;AAEA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,sCAAA;EACA,WAAA;EACA,YAAA;AACF;AACE;EACE,mBAAA;AACJ;AAEE;EACE,SAAA;EACA,YAAA;EACA,qBAAA;EACA,yBAAA;EACA,aAAA;AAAJ;;AAIA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,cAAA;AADF;AAGE;EANF;IAOI,sBAAA;IACA,oBAAA;IACA,WAAA;EAAF;AACF;;AAGA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,WAAA;AAAF;AAEE;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AAAJ;AAEI;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAAN;AAIE;EArBF;IAsBI,sBAAA;EADF;AACF;;AAIA;EACE,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AADF;AAGE;EACE,yBAAA;AADJ;AAIE;EACE,yBAAA;EACA,mBAAA;AAFJ;AAKE;EACE,yBAAA;AAHJ;AAKI;EACE,yBAAA;AAHN;AAOE;EACE,yBAAA;AALJ;AAOI;EACE,yBAAA;AALN;AASE;EAtCF;IAuCI,WAAA;EANF;AACF;;AASA;EACE,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;AANF;;AASA;EACE,YAAA;EACA,oBAAA;AANF;;AASA;EACE,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,sBAAA;EACA,mBAAA;EACA,4BAAA;EACA,kBAAA;EACA,uBAAA;EACA,8FACE;EAEF,uCAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AARF;AASE;EAlBF;IAmBI,WAAA;EANF;AACF;;AASA;EACE,+FACE;AAPJ;;AAUA;EACE,iBAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;AAPF;;AASA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AANF;;AAQA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;AALF;;AAOA;EACE,0CAAA;EACA,qBAAA;EACA,eAAA;EACA,6CAAA;EAAA,qCAAA;EAAA,wEAAA;AAJF;;AAOA;EACE,0BAAA;AAJF;;AAOA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,WAAA;EACA,8BAAA;EACA,qBAAA;AAJF;;AAOA;EACE,aAAA;AAJF;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAJF;;AAOA;EACE,YAAA;EACA,8BAAA;AAJF;;AAOA;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;AAJF;;AAOA;EACE,0BAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kFACE;AALJ;AAQE;EACE,wHACE;AAPN;;AAaA;EACE,0BAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,yCAAA;EACA,uBAAA;EACA,YAAA;EACA,kFACE;EAEF,2DACE;AAbJ;AAgBE;EACE,wHACE;AAfN;AAoBE;EACE,sBAAA;AAlBJ;;AAsBA;EACE,iBAAA;AAnBF;;AAsBA;EACE,6BAAA;AAnBF;;AAqBA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;AAlBF;;AAqBA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,wDAAA;EACA,aAAA;EACA,gBAAA;AAlBF;;AAqBA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,+HAAA;EASA,0CAAA;AA1BF;;AA6BA;EACE,kBAAA;EACA,UAAA;AA1BF;;AA6BA;EACE,oCAAA;EACA,mBAAA;EACA,aAAA;EACA,uCAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;AA1BF;;AA6BA;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,2CAAA;EACA,mBAAA;EACA,cAAA;AA1BF;;AA6BA;EACE,cAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;AA1BF;;AA6BA;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;AA1BF;AA4BE;EACE,mBAAA;EACA,sBAAA;AA1BJ;;AA8BA;EACE,kBAAA;EACA,WAAA;EACA,OAAA;EACA,aAAA;EACA,aAAA;EACA,6BAAA;EACA,eAAA;AA3BF;;AA8BA;EACE,oCAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;AA3BF;;AA8BA;EACE;IACE,wBAAA;EA3BF;EA6BA;IACE,6BAAA;EA3BF;AACF;AA8BA;EACE;IACE,YAAA;EA5BF;EA8BA;IACE,UAAA;EA5BF;EA8BA;IACE,YAAA;EA5BF;AACF;AA+BA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,eAAA;AA7BF;;AAgCA;EACE;IACE,YAAA;IACA,aAAA;EA7BF;EAgCA;;IAEE,gBAAA;EA9BF;EAiCA;IACE,eAAA;EA/BF;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  padding: 40px;\n  background-color: #f5f5f5;\n  overflow-x: hidden;\n\n  @media (max-width: 768px) {\n    padding: 16px;\n  }\n}\n\n.wishContainer {\n  background: white;\n  border-radius: 12px;\n  padding: 32px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  min-height: calc(100vh - 80px);\n  display: flex;\n  flex-direction: column;\n  overflow-x: hidden;\n\n  @media (max-width: 768px) {\n    padding: 20px;\n    min-height: calc(100vh - 32px);\n  }\n}\n\n.header {\n  margin-bottom: 24px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #eaeaea;\n\n  h2 {\n    font-size: 1.75rem;\n    color: #333;\n    margin: 0;\n    font-weight: 600;\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n  }\n\n  h3 {\n    font-size: 1.25rem;\n    color: #666;\n    margin: 8px 0 0 0;\n    font-weight: normal;\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n  }\n}\n\n.wishes {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.wish {\n  background: #f8f9fa;\n  border-radius: 8px;\n  padding: 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n  transition: background-color 0.2s ease;\n  width: 100%;\n  min-width: 0;\n\n  &:hover {\n    background: #f0f0f0;\n  }\n\n  .wishText {\n    flex: 1;\n    min-width: 0;\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n    hyphens: auto;\n  }\n}\n\n.wishActions {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  flex-shrink: 0;\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n    align-items: stretch;\n    width: 100%;\n  }\n}\n\n.bookingForm {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  width: 100%;\n\n  input {\n    padding: 8px 12px;\n    border: 1px solid #ced4da;\n    border-radius: 6px;\n    font-size: 0.875rem;\n    min-width: 0;\n    width: 100%;\n\n    &:focus {\n      outline: none;\n      border-color: #007bff;\n      box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n    }\n  }\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n  }\n}\n\nbutton {\n  padding: 8px 16px;\n  border-radius: 6px;\n  border: none;\n  background-color: #007bff;\n  color: white;\n  cursor: pointer;\n  font-size: 0.875rem;\n  transition: all 0.2s ease;\n  white-space: normal;\n  text-align: center;\n  min-height: 36px;\n\n  &:hover:not(:disabled) {\n    background-color: #0056b3;\n  }\n\n  &:disabled {\n    background-color: #cccccc;\n    cursor: not-allowed;\n  }\n\n  &.unbookButton {\n    background-color: #dc3545;\n\n    &:hover:not(:disabled) {\n      background-color: #c82333;\n    }\n  }\n\n  &.searchButton {\n    background-color: #28a745;\n\n    &:hover:not(:disabled) {\n      background-color: #218838;\n    }\n  }\n\n  @media (max-width: 768px) {\n    width: 100%;\n  }\n}\n\n.bookedStatus {\n  font-size: 0.875rem;\n  color: #666;\n  font-style: italic;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n}\n\n.loading {\n  opacity: 0.7;\n  pointer-events: none;\n}\n\n.wish {\n  min-width: 350px;\n  min-height: 300px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  max-width: min-content;\n  align-items: center;\n  padding: 16px 16px 32px 16px;\n  border-radius: 8px;\n  background-color: white;\n  box-shadow:\n    0 4px 6px -1px rgba(255, 255, 255, 0.5),\n    0px 2px 4px -2px rgba(255, 255, 255, 0.6);\n  transition: box-shadow 0.3s ease-in-out;\n  text-align: center;\n  position: relative;\n  max-height: 500px;\n  @media (max-width: 500px) {\n    width: 90vw;\n  }\n}\n\n.wish:hover {\n  box-shadow:\n    0 5px 15px -3px rgba(255, 255, 255, 0.7),\n    0px 3px 6px -2px rgba(255, 255, 255, 0.8);\n}\n.wishes {\n  padding-top: 10px;\n  overflow: auto;\n  width: 100%;\n  text-align: left;\n}\n.wrapper {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  justify-content: center;\n  align-items: center;\n}\n.name {\n  position: absolute;\n  right: 10px;\n  bottom: 4px;\n}\n.font {\n  font-family: \"Times New Roman\", sans-serif;\n  word-break: break-all;\n  cursor: pointer;\n  transition: text-decoration 0.3s ease;\n}\n\n.font:hover {\n  text-decoration: underline;\n}\n\n.row {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n  width: 100%;\n  justify-content: space-between;\n  word-wrap: break-word;\n}\n\n.info {\n  display: flex;\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.column {\n  padding: 5px;\n  border-bottom: 1px solid black;\n}\n\n.popup {\n  background: #282c34;\n  display: flex;\n  flex-direction: column;\n  right: 0;\n  margin-left: 8px;\n  padding: 20px;\n  font-size: 14px;\n  border-radius: 8px;\n}\n\n.input {\n  cursor: pointer !important;\n  border: unset;\n  font-size: 16px;\n  outline: none;\n  padding: 8px;\n  border-radius: 10px;\n  transition: all 0.3s ease;\n  box-shadow:\n    0 4px 6px rgba(255, 255, 255, 0.3),\n    0 1px 3px rgba(255, 255, 255, 0.2);\n\n  &:hover {\n    box-shadow:\n      0 10px 15px rgba(255, 255, 255, 0.4),\n      0 3px 6px rgba(255, 255, 255, 0.3),\n      0 2px 4px rgba(255, 255, 255, 0.2);\n  }\n}\n\n.button {\n  cursor: pointer !important;\n  font-size: 16px;\n  color: black;\n  margin: 10px;\n  padding: 8px 16px;\n  border-radius: 10px;\n  font-family: \"RubikMoonrocks\", sans-serif;\n  background-color: white;\n  border: none;\n  box-shadow:\n    0 4px 6px rgba(255, 255, 255, 0.3),\n    0 1px 3px rgba(255, 255, 255, 0.2);\n  transition:\n    transform 0.1s ease,\n    background-color 0.2s ease;\n\n  &:hover {\n    box-shadow:\n      0 10px 15px rgba(255, 255, 255, 0.4),\n      0 3px 6px rgba(255, 255, 255, 0.3),\n      0 2px 4px rgba(255, 255, 255, 0.2);\n  }\n\n  &:active {\n    transform: scale(0.95);\n  }\n}\n\n.loading {\n  filter: blur(1px);\n}\n\n.del {\n  text-decoration: line-through;\n}\n.toogleHide {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.christmasContainer {\n  position: relative;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(to bottom, #1a472a, #2d5a40);\n  padding: 20px;\n  overflow: hidden;\n}\n\n.lights {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: repeating-linear-gradient(\n    90deg,\n    #ff0000 0px,\n    #ff0000 10px,\n    #00ff00 10px,\n    #00ff00 20px,\n    #0000ff 20px,\n    #0000ff 30px\n  );\n  animation: twinkle 1s infinite;\n}\n\n.wrapper {\n  position: relative;\n  z-index: 1;\n}\n\n.christmasCard {\n  background: rgba(255, 255, 255, 0.9);\n  border-radius: 15px;\n  padding: 30px;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);\n  position: relative;\n  margin: 20px auto;\n  max-width: 800px;\n  border: 2px solid #c41e3a;\n}\n\n.name {\n  color: #c41e3a;\n  font-size: 1.5em;\n  font-weight: bold;\n  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);\n  margin-bottom: 15px;\n  display: block;\n}\n\n.wishTitle {\n  color: #1a472a;\n  font-size: 2em;\n  margin: 15px 0;\n  display: block;\n  text-align: center;\n}\n\n.toggleHide {\n  background: #c41e3a;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 25px;\n  cursor: pointer;\n  font-size: 1.1em;\n  transition: all 0.3s ease;\n  margin: 10px;\n\n  &:hover {\n    background: #8b0000;\n    transform: scale(1.05);\n  }\n}\n\n.decorations {\n  position: absolute;\n  width: 100%;\n  left: 0;\n  bottom: -10px;\n  display: flex;\n  justify-content: space-around;\n  font-size: 24px;\n}\n\n.wishes {\n  background: rgba(255, 255, 255, 0.8);\n  border-radius: 10px;\n  padding: 20px;\n  margin: 20px 0;\n}\n\n@keyframes snow {\n  0% {\n    background-position: 0 0;\n  }\n  100% {\n    background-position: 0 1536px;\n  }\n}\n\n@keyframes twinkle {\n  0% {\n    opacity: 0.7;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0.7;\n  }\n}\n\n.holly {\n  position: absolute;\n  top: -15px;\n  left: 50%;\n  transform: translateX(-50%);\n  font-size: 30px;\n}\n\n@media (max-width: 768px) {\n  .christmasCard {\n    margin: 10px;\n    padding: 20px;\n  }\n\n  .name,\n  .wishTitle {\n    font-size: 1.2em;\n  }\n\n  .decorations {\n    font-size: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Wish_container__Jkm0y`,
	"wishContainer": `Wish_wishContainer__WzQ8Z`,
	"header": `Wish_header__DK5q9`,
	"wishes": `Wish_wishes__P4xlV`,
	"wish": `Wish_wish__XB7An`,
	"wishText": `Wish_wishText__J0lRP`,
	"wishActions": `Wish_wishActions__YK1lb`,
	"bookingForm": `Wish_bookingForm__oaV6o`,
	"unbookButton": `Wish_unbookButton__6d3+p`,
	"searchButton": `Wish_searchButton__STmPg`,
	"bookedStatus": `Wish_bookedStatus__8YM82`,
	"loading": `Wish_loading__D+h0A`,
	"wrapper": `Wish_wrapper__7sayo`,
	"name": `Wish_name__kwRbg`,
	"font": `Wish_font__XeY8M`,
	"row": `Wish_row__zPG1s`,
	"info": `Wish_info__WvpUK`,
	"actions": `Wish_actions__Vy-eo`,
	"column": `Wish_column__vUIF0`,
	"popup": `Wish_popup__R6ZEo`,
	"input": `Wish_input__WMDwy`,
	"button": `Wish_button__99326`,
	"del": `Wish_del__0cyNK`,
	"toogleHide": `Wish_toogleHide__AD2lC`,
	"christmasContainer": `Wish_christmasContainer__xtg37`,
	"lights": `Wish_lights__3r7UL`,
	"twinkle": `Wish_twinkle__6M5A2`,
	"christmasCard": `Wish_christmasCard__+XSod`,
	"wishTitle": `Wish_wishTitle__Eo4hS`,
	"toggleHide": `Wish_toggleHide__r96OQ`,
	"decorations": `Wish_decorations__cxhLH`,
	"holly": `Wish_holly__TSmU+`,
	"snow": `Wish_snow__5yp-x`
};
export default ___CSS_LOADER_EXPORT___;
